import { render } from "./afterSales-popup.vue?vue&type=template&id=675a6a10&scoped=true"
import script from "./afterSales-popup.vue?vue&type=script&lang=js"
export * from "./afterSales-popup.vue?vue&type=script&lang=js"

import "./afterSales-popup.vue?vue&type=style&index=0&id=675a6a10&scoped=true&lang=scss"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675a6a10"]])

export default __exports__